import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ManuallyProvidePaletteColor from './ManuallyProvidePaletteColor';
import ClientProvider from './client';
export default createDemo(import.meta.url, ManuallyProvidePaletteColor, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/palette/demos/manually-provide-color/ManuallyProvidePaletteColor.tsx",
    "fileName": "ManuallyProvidePaletteColor.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { createTheme, ThemeProvider } from '@mui/material/styles';\nimport Button from '@mui/material/Button';\nimport Box from '@mui/material/Box';\nimport Stack from '@mui/material/Stack';\nimport { unstable_capitalize as capitalize } from '@mui/utils';\nimport Typography from '@mui/material/Typography';\n\nconst theme = createTheme({\n  palette: {\n    primary: {\n      main: '#FF5733',\n      // light: will be calculated from palette.primary.main,\n      // dark: will be calculated from palette.primary.main,\n      // contrastText: will be calculated to contrast with palette.primary.main\n    },\n    secondary: {\n      main: '#E0C2FF',\n      light: '#F5EBFF',\n      // dark: will be calculated from palette.secondary.main,\n      contrastText: '#47008F',\n    },\n  },\n});\n\nfunction ColorShowcase({ color }: { color: 'primary' | 'secondary' }) {\n  return (\n    <Stack sx={{ gap: 2, alignItems: 'center' }}>\n      <Button variant=\"contained\" color={color}>\n        {capitalize(color)}\n      </Button>\n      <Stack direction=\"row\" sx={{ gap: 1 }}>\n        <Stack sx={{ alignItems: 'center' }}>\n          <Typography variant=\"body2\">light</Typography>\n          <Box sx={{ bgcolor: `${color}.light`, width: 40, height: 20 }} />\n        </Stack>\n        <Stack sx={{ alignItems: 'center' }}>\n          <Typography variant=\"body2\">main</Typography>\n          <Box sx={{ bgcolor: `${color}.main`, width: 40, height: 20 }} />\n        </Stack>\n        <Stack sx={{ alignItems: 'center' }}>\n          <Typography variant=\"body2\">dark</Typography>\n          <Box sx={{ bgcolor: `${color}.dark`, width: 40, height: 20 }} />\n        </Stack>\n      </Stack>\n    </Stack>\n  );\n}\n\nexport default function ManuallyProvidePaletteColor() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider theme={theme}>\n      <Stack direction=\"row\" sx={{ gap: 8 }}>\n        <ColorShowcase color=\"primary\" />\n        <ColorShowcase color=\"secondary\" />\n      </Stack>\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 58,
        "focusedLines": 6,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { createTheme, ThemeProvider } from '@mui/material/styles';\nimport Button from '@mui/material/Button';\nimport Box from '@mui/material/Box';\nimport Stack from '@mui/material/Stack';\nimport { unstable_capitalize as capitalize } from '@mui/utils';\nimport Typography from '@mui/material/Typography';\n\nconst theme = createTheme({\n  palette: {\n    primary: {\n      main: '#FF5733',\n      // light: will be calculated from palette.primary.main,\n      // dark: will be calculated from palette.primary.main,\n      // contrastText: will be calculated to contrast with palette.primary.main\n    },\n    secondary: {\n      main: '#E0C2FF',\n      light: '#F5EBFF',\n      // dark: will be calculated from palette.secondary.main,\n      contrastText: '#47008F',\n    },\n  },\n});\n\nfunction ColorShowcase({ color }: { color: 'primary' | 'secondary' }) {\n  return (\n    <Stack sx={{ gap: 2, alignItems: 'center' }}>\n      <Button variant=\"contained\" color={color}>\n        {capitalize(color)}\n      </Button>\n      <Stack direction=\"row\" sx={{ gap: 1 }}>\n        <Stack sx={{ alignItems: 'center' }}>\n          <Typography variant=\"body2\">light</Typography>\n          <Box sx={{ bgcolor: `${color}.light`, width: 40, height: 20 }} />\n        </Stack>\n        <Stack sx={{ alignItems: 'center' }}>\n          <Typography variant=\"body2\">main</Typography>\n          <Box sx={{ bgcolor: `${color}.main`, width: 40, height: 20 }} />\n        </Stack>\n        <Stack sx={{ alignItems: 'center' }}>\n          <Typography variant=\"body2\">dark</Typography>\n          <Box sx={{ bgcolor: `${color}.dark`, width: 40, height: 20 }} />\n        </Stack>\n      </Stack>\n    </Stack>\n  );\n}\n\nexport default function ManuallyProvidePaletteColor() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <ThemeProvider theme={theme}>\n      <Stack direction=\"row\" sx={{ gap: 8 }}>\n        <ColorShowcase color=\"primary\" />\n        <ColorShowcase color=\"secondary\" />\n      </Stack>\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 51
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "theme"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 52
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Stack"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "direction"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "row",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "gap"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "8"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 53
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "ColorShowcase"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "primary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 54
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "ColorShowcase"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "secondary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 55
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Stack"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 56
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 58,
    "focusedLines": 6,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Button",
      "@mui/material/Box",
      "@mui/material/Stack",
      "@mui/utils",
      "@mui/material/Typography"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
